<template>
  <main class="m">
    <h1 class="docs__title">Техническая документация</h1>
    <div class="m__container">
        <div class="m-left">
          <TechDocs></TechDocs>
        </div>
        <div class="m-right">
          <ContactForm></ContactForm>
        </div>
    </div>
  </main>
</template>

<script>

import TechDocs from '@/components/TechDocs.vue'
import ContactForm from '@/components/ContactForm3.vue'
// @ is an alias to /src

export default {
  name: 'Home',
  components: {
    TechDocs,
    ContactForm
  }
}
</script>

<style lang="sass">
h1,
h2,
h3,
h4,
h5,
h6
  display: block
  line-height: 1.1
  font-weight: 700
  
h1
  margin: 0
  font-size: 30px
h2
  font-size: 23px
  font-weight: 500
.m
  flex: 1
  &__container
    display: flex
    @media screen and (max-width: 767.99px)
      flex-direction: column
    @media screen and (min-width: 768px)
      flex-direction: row
  &-left
    flex: 60%
  &-right
    flex: 40%
    
  &-search
    padding: 30px 0
    display: flex
    flex-direction: row
    align-items: center
    &__info
      margin-left: 15px
</style>